import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { LoadingState, EmptyState } from "@/components/shared";
import { Button } from "@/components/ui/button";
import { TopCandidates } from "@/components/job/ScreeningStep";
import { CalendarClock, Handshake } from "lucide-react";

const KINDS = {
  interviews: { stages: ["interview"], title: "Candidates in interview", icon: CalendarClock, empty: "No one is in interview yet", hint: "Move strong applicants to Interview from the candidate board, then schedule from Interviews." },
  offer: { stages: ["offer", "hired"], title: "Offers & hires", icon: Handshake, empty: "No offers yet", hint: "Candidates you move to Offer or Hired appear here." },
};

export function StageStep({ job, kind }) {
  const nav = useNavigate();
  const cfg = KINDS[kind];
  const [cands, setCands] = useState(null);
  const [interviews, setInterviews] = useState([]);
  useEffect(() => {
    api.get(`/jobs/${job.id}/candidates`).then((r) => setCands(r.data.filter((c) => cfg.stages.includes(c.stage)))).catch(() => setCands([]));
    if (kind === "interviews") api.get("/interviews").then((r) => setInterviews((r.data || []).filter((i) => i.job_id === job.id && i.status === "scheduled"))).catch(() => {});
  }, [job.id, kind, cfg.stages]);

  if (!cands) return <LoadingState label="Loading…" />;
  return (
    <div className="app-container py-8 space-y-6" data-testid={`stage-step-${kind}`}>
      {kind === "interviews" && interviews.length > 0 && (
        <section className="rounded-xl border border-border bg-card divide-y divide-border/60" data-testid="job-interviews">
          <div className="flex items-center justify-between px-5 py-4">
            <h2 className="font-semibold">Scheduled</h2>
            <button onClick={() => nav("/recruiter/interviews")} className="text-sm text-primary hover:underline" data-testid="open-interviews">Open interviews →</button>
          </div>
          {interviews.map((i) => (
            <div key={i.id} className="px-5 py-3.5 flex flex-wrap items-center gap-3 text-sm" data-testid={`job-interview-${i.id}`}>
              <CalendarClock className="h-4 w-4 text-sky-500" />
              <span className="font-medium">{i.candidate_name}</span>
              <span className="text-muted-foreground">{new Date(i.when).toLocaleString(undefined, { weekday: "short", day: "numeric", month: "short", hour: "2-digit", minute: "2-digit" })} · {i.duration_min}m {i.mode}</span>
            </div>
          ))}
        </section>
      )}
      {cands.length ? <TopCandidates cands={cands} jobId={job.id} title={cfg.title} />
        : <EmptyState icon={cfg.icon} title={cfg.empty} description={cfg.hint} action={<Button variant="outline" className="mt-2" onClick={() => nav(`/recruiter/pipeline?job=${job.id}`)} data-testid="stage-open-board">Open candidate board</Button>} />}
    </div>
  );
}
